module.exports = __webpack_public_path__ + "static/img/shifeiji.71615e96.png";